import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { useProgressiveImage } from '~/src/helpers/hooks/useProgressiveImage';

export const Wrapper = styled.div<{ bgImage: string, bgWebpImage: string }>`
    min-width: 320px;
    height: 96px;
    background: url(${({ bgWebpImage, bgImage }) => useProgressiveImage(bgWebpImage, {
        hasTimeout: true,
        timeoutDelay: 1,
    }, bgImage)}) no-repeat;
    background-size: cover;
    justify-content: space-between;
    flex-wrap: nowrap;

    img, p {
        height: 100%;
    }

    p {
        display: flex;
        align-items: center;
        ${FONTS.S};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        height: 64px;

        p {
            ${FONTS.XXS};
        }

        img {
            width: 96px;
        }
    }
`;

export const ImageBlock = styled(LazyLoadImage)`
    width: auto;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    object-fit: cover;
`;
